import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
import type { ESignPackage } from '../types/docmagic';
import { derivePackageStatus } from '../utils/packageStatus';
import { formatDateTime } from '../utils/datetime';
import { StatusBadge } from './StatusBadge';
interface PackageHeaderProps {
  pkg: ESignPackage;
  syncing: boolean;
  onSync: () => void;
}
export function PackageHeader({
  pkg,
  syncing,
  onSync
}: PackageHeaderProps) {
  const status = derivePackageStatus(pkg);
  const fields = [{
    label: 'DocMagic Package ID',
    value: pkg.docMagicPackageId,
    mono: true
  }, {
    label: 'RCM Loan Number',
    value: pkg.rcmLoanNumber ?? '',
    mono: true
  }, {
    label: 'Matched By',
    value: pkg.matchMethod === 'Borrower Email' ? `Borrower Email · ${pkg.matchEmail ?? ''}` : 'RCM Loan Number'
  }, {
    label: 'Last Synced',
    value: formatDateTime(pkg.lastSyncedAt)
  }];
  return <div className="border-b border-line px-4 py-4" data-id="element-110" data-mp="18ormg04ektir">
      <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-111" data-mp="18rnmpv3q3uad">
        <div className="min-w-0" data-id="element-112" data-mp="1g0lz5nok02nw">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted" data-id="element-113" data-mp="1g0vttokjmxzx">{pkg.type}</p>
          <div className="mt-1 flex flex-wrap items-center gap-2" data-id="element-114" data-mp="1b6hpuxrtfijn">
            <h2 className="text-lg font-bold text-ink" data-id="element-115" data-mp="1778x9w8ihqpo">{pkg.title}</h2>
            <StatusBadge status={status} data-id="element-116" data-mp="128fkk611u3qk" />
            {pkg.matchStatus === 'Unmatched' && <span className="rounded border border-[#f7d59c] bg-[#fef5e6] px-2 py-0.5 text-xs font-semibold text-warning" data-id="element-117" data-mp="1yy6pz0avpbb5">
                Unmatched
              </span>}
          </div>
        </div>
        <button type="button" onClick={onSync} disabled={syncing} className="inline-flex items-center gap-1.5 rounded border border-line-strong bg-white px-3 py-1.5 text-sm font-medium text-brand hover:bg-canvas focus:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-wait disabled:opacity-70" data-id="element-118" data-mp="1pw5uo8z7gzc4">
          <RefreshCwIcon className={`h-4 w-4 ${syncing ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-119" data-mp="b0e1uo96bep1" />
          {syncing ? 'Syncing…' : 'Sync with DocMagic'}
        </button>
      </div>
      <dl className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3 lg:grid-cols-4" data-id="element-120" data-mp="1zg60t8w2dhj">
        {fields.map(f => <div key={f.label} className="min-w-0" data-id="element-121" data-mp="6yam3nfh1nxy">
            <dt className="text-xs text-muted" data-id="element-122" data-mp="6wzhxmi46e6b">{f.label}</dt>
            <dd className={`truncate text-sm text-ink ${f.mono ? 'font-mono' : ''}`} data-id="element-123" data-mp="3oeiop3ulcijk">{f.value}</dd>
          </div>)}
      </dl>
    </div>;
}